import { connect } from 'react-redux'
import { compose, lifecycle, withHandlers } from 'recompose';
import { reduxForm } from 'redux-form'
import { fetchOperator, persistOperator, deleteOperator} from '../store/actions/operators';
import OperatorForm from '../components/operator/OperatorForm';
import { withLoadingComponent, withErrorComponent } from '../components/loading';
import { withRouter } from 'react-router-dom'

const mapStateToProps = (state, ownProps) => {

    const operatorId = ownProps.match.params.operatorId;
    const operator = operatorId !== undefined?state.operatorPage.operator:{id:0};

    return {
        exportUrl: state.fileexport.url,
        ...state.operatorPage,
        initialValues: operator,
    };
};

const mapDispatchToProps = (dispatch, ownProps) => {
    const customerId = ownProps.match.params.customerId;
    const branchId = ownProps.match.params.branchId;
    const operatorId = ownProps.match.params.operatorId;

    return {
        fetchOperator: () => {
            if(operatorId) {
                dispatch(fetchOperator(branchId, operatorId))
            } else {
                dispatch({
                    type: "FETCH_OPERATOR_SUCCESS",
                    payload: {id: 0}
                });
            }
        },
        deleteOperator: () => {
            dispatch(deleteOperator(branchId, operatorId)).then(r => {
                ownProps.history.push(`/customers/${customerId}/${branchId}/operators`)
            })
        },
        onSubmit: (data)=> {
            dispatch(persistOperator(branchId, data)).then(r => {
                ownProps.history.push(`/customers/${customerId}/${branchId}/operators`)
            })
        },


    }
};


const lifecycleValue = {
    componentWillMount() {
        this.props.fetchOperator();
    }
};

export default compose(
    withRouter,
    connect(mapStateToProps, mapDispatchToProps),
    lifecycle(lifecycleValue),
    withErrorComponent,
    withLoadingComponent,
    reduxForm({form: 'operatorForm'}),
    withHandlers({
        onBackClick: props => () =>{props.history.goBack()}
    })
)(OperatorForm);



// WEBPACK FOOTER //
// ./src/containers/OperatorContainer.js